import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

export function readContent(
  params: OpalApiRequestParams<'ReadContentV2'>
): Promise<OpalApiResponseDocument<'ReadContentV2', 200>> {
  const url = new URL(
    `/content/v2/${params.path.content_id}`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
